import { ContentItemFragment } from 'app/graphql/__generated__/types/contento';
import CONTENTO_TYPES from 'app/domain/ContentoTypes';

export const getProgress = (content: ContentItemFragment, continueWatchingIsActive: boolean): number => {
    if (
        continueWatchingIsActive &&
        (content.item.__typename === CONTENTO_TYPES.EPISODE ||
            content.item.__typename === CONTENTO_TYPES.SINGLE ||
            content.item.__typename === CONTENTO_TYPES.VARIANT)
    ) {
        if (content.progressFraction) {
            return content.progressFraction;
        }
    }

    return 0;
};
